import React from 'react';

/**
 * Перше, на що потрапляє Tab: без нього людина з клавіатури проходить усю
 * шапку з випадними списками на кожній сторінці, перш ніж дістатися змісту.
 * Ціль — <main id="content"> (PageShell і головна).
 */
const SkipLink = () => (
  <a
    href="#content"
    className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:rounded-sm focus:bg-white focus:px-4 focus:py-2 focus:text-slate-900 focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-teal-600"
  >
    Перейти до вмісту
  </a>
);

export default SkipLink;
